import { MainProduct } from "@/types/productTypes";

export const getProduct = (
   allProducts: MainProduct[] | undefined,
   productId: number
) => {
   return allProducts?.find((p) => p.id === productId);
};

export const getStage = (
   allProducts: MainProduct[] | undefined,
   productId: number,
   stageId: number
) => {
   return getProduct(allProducts, productId)?.stages.find(
      (stage) => stage.id === stageId
   );
};

export const getOption = (
   allProducts: MainProduct[] | undefined,
   productId: number,
   stageId: number,
   optionId: number
) => {
   return getStage(allProducts, productId, stageId)?.options?.find(
      (option) => option.id === optionId
   );
};
export const getItem = (
   allProducts: MainProduct[] | undefined,
   productId: number,
   stageId: number,
   optionId: number,
   itemId: number
) => {
   return getOption(allProducts, productId, stageId, optionId)?.items?.find(
      (item) => item.id === itemId
   );
};
